import KondoHeader from '../Header';
import KondoFooter from '../Footer';
import ContactButton from '../ContactButton'
import Pankuzu from '../pankuzu';
import NewsTop from "../../images/NewsTop.png";
import NewsArticle_01 from "../../images/NewsArticle_01.png";
import NewsArticle_02 from "../../images/NewsArticle_02.png";
import NewsArticle_03 from "../../images/NewsArticle_03.png";

import {WordpressAPI} from "../../components";

// animation
import {motion} from "framer-motion"

const PageNews = () => {
    return(
        <div id="PageKondou">  
            <div id="PageNews">
                <KondoHeader />
                <motion.div
                    animate={{
                        y: 0,
                        opacity: 1
                    }}
                    initial={{
                        y: 0,
                        opacity: 1
                    }}
                    exit={{
                        y: 100,
                        opacity: 0
                    }}
                    transition={{
                        duration: 0.4,
                        ease: "easeOut",
                    }}
                >
                    <main>
                        <section className='news-top'>
                            <img src={NewsTop} alt='お知らせ・ニュース' />
                            <Pankuzu pagename="お知らせ・ニュース" />
                            <article>
                                <h1>NEWS</h1>
                                <h2>お知らせ・ニュース</h2>
                            </article>
                        </section>
                        <WordpressAPI />
                        <section className='tag-category'>
                            <div>
                                <h3>カテゴリ</h3>
                                <button className='active-button'>お知らせ</button>
                                <button className='event-button'>イベント</button>
                                <button className='passive-button'>キャンペーン</button>
                            </div>
                            <div>
                                <h3>年</h3>
                                <h4>2022年</h4>
                                <h4>2021年</h4>
                            </div>
                        </section>
                        <section className='news-article'>
                            <article>
                                <a href='http://www.kondo-some.co.jp/blog/?p=1217'>
                                    <div>               
                                        <img src={NewsArticle_01} alt='NewsArticle' />
                                        <h1 className='new-color'>お知らせ</h1>
                                        <h2>2023.01.30</h2>
                                        <p>2月の営業について</p>
                                    </div>
                                </a>
                            </article>
                            <article>
                                <a href='http://www.kondo-some.co.jp/blog/?p=1213'>
                                    <div>               
                                        <img src={NewsArticle_02} alt='NewsArticle' />
                                        <h1 className='new-color'>お知らせ</h1>
                                        <h2>2023.01.13</h2>
                                        <p>1月の営業について</p>
                                    </div>
                                </a>
                            </article>
                            <article>
                                <a href='http://www.kondo-some.co.jp/blog/?p=1202'>
                                    <div>               
                                        <img src={NewsArticle_03} alt='NewsArticle' />
                                        <h1 className='new-color'>お知らせ</h1>
                                        <h2>2022.12.02</h2>
                                        <p>12月の営業について</p>
                                    </div>
                                </a>
                            </article>
                            <article>
                                <a href='http://www.kondo-some.co.jp/blog/?p=1200'>
                                    <div>            
                                        <img src={NewsArticle_03} alt='NewsArticle' />
                                        <h1 className='new-color'>お知らせ</h1>
                                        <h2>2022.11.01</h2>
                                        <p>11月の営業について</p>
                                    </div>
                                </a>
                            </article>
                            <article>
                                <a href='http://www.kondo-some.co.jp/blog/?p=1184'>
                                    <div>            
                                        <img src={NewsArticle_03} alt='NewsArticle' />
                                        <h1 className='new-color'>お知らせ</h1>
                                        <h2>2022.09.26</h2>
                                        <p>10月の営業について</p>
                                    </div>
                                </a>
                            </article>
                            <article>
                                <a href='http://www.kondo-some.co.jp/blog/?p=1180'>
                                    <div>            
                                        <img src={NewsArticle_03} alt='NewsArticle' />
                                        <h1 className='new-color'>お知らせ</h1>
                                        <h2>2022.08.02</h2>
                                        <p>9月の営業について</p>
                                    </div>
                                </a>
                            </article>
                            <article>
                                <a href='http://www.kondo-some.co.jp/blog/?p=1176'>
                                    <div>            
                                        <img src={NewsArticle_03} alt='NewsArticle' />
                                        <h1 className='new-color'>お知らせ</h1>
                                        <h2>2022.08.31</h2>
                                        <p>オンラインショップでクレジットカード<br/>が使えるようになりました</p>
                                    </div>
                                </a>
                            </article>
                            <article>
                                <a href='http://www.kondo-some.co.jp/blog/?p=1176'>
                                    <div>            
                                        <img src={NewsArticle_03} alt='NewsArticle' />
                                        <h1 className='new-color'>お知らせ</h1>
                                        <h2>2022.07.30</h2>
                                        <p>8月の営業について</p>
                                    </div>
                                </a>
                            </article>
                            <article>
                                <a href='http://www.kondo-some.co.jp/blog/?p=1176'>
                                    <div>            
                                        <img src={NewsArticle_03} alt='NewsArticle' />
                                        <h1 className='new-color'>お知らせ</h1>
                                        <h2>2022.07.01</h2>
                                        <p>7月の営業についてと<br/>先日のイベント出店のご報告</p>
                                    </div>
                                </a>
                            </article>
                            {/* 
                            <article>
                                <div>               
                                    <img src={NewsArticle_01} alt='NewsArticle' />
                                    <h1 className='new-color'>お知らせ</h1>
                                    <h2>2021.11.1</h2>
                                    <p>ニュースタイトルが入ります</p>
                                </div>
                            </article>
                            <article>
                                <div>               
                                    <img src={NewsArticle_02} alt='NewsArticle' />
                                    <h1 className='event-color'>イベント</h1>
                                    <h2>2021.11.1</h2>
                                    <p>ニュースタイトルが入ります</p>
                                </div>
                            </article>
                            <article>
                                <div>               
                                    <img src={NewsArticle_03} alt='NewsArticle' />
                                    <h1 className='campaign-color'>キャンペーン</h1>
                                    <h2>2021.11.1</h2>
                                    <p>ニュースタイトルが入ります</p>
                                </div>
                            </article>
                            */}
                        </section>
                    </main>
                    <ContactButton />
                    <KondoFooter />
                </motion.div>
            </div>
        </div>
    )
}
export default PageNews;